import React, { useEffect, useState } from "react";
import RolesTable from "./components/RolesTable";
import Edit from "./modals/Edit";
import Log from "./modals/Log";
import Delete from "./modals/Remove";
import Create from "./modals/Create";
import Divider from "@material-ui/core/Divider/index";
import axios from "axios";

function Roles(props) {
  const [roles, setRoles] = useState([]);
  const [chooseRoleId, setChooseRoleId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteRolesIds, setDeleteRolesIds] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showLog, setShowLog] = useState(false);

  

  const onRoles = () => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}role`)
      .then(({ data }) => {
        setIsLoading(false);
        setRoles(data);
        setIsError(false);
      })
      .catch(() => {
        setIsLoading(false);
        setRoles([]);
        setIsError(true);
      });
  };

  const onRoleChoose = (chooseRoleId) => {
    return axios.get(`${process.env.REACT_APP_API_URL}role/${chooseRoleId}`, );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onRoles();
    }, 500);
    return () => clearTimeout(timer);
  }, []);


  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}permission`)
      .then((res) => {
        const permissions = res.data.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setPermissions(permissions);
      });
  }, []);

  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Rollar</h1>
      </div>
      <Divider className="w-100" />
      <RolesTable
        roles={roles}
        isLoading={isLoading}
        isError={isError}
        setChooseRoleId={setChooseRoleId}
        setShowCreate={setShowCreate}
        setShowRemove={setShowRemove}
        setShowEdit={setShowEdit}
        setDeleteRolesIds={setDeleteRolesIds}
        deleteRolesIds={deleteRolesIds}
        setShowLog={setShowLog}

      />
      <Log
        chooseRoleId={chooseRoleId}
        onRoleChoose={onRoleChoose}
        setChooseRoleId={setChooseRoleId}
        showLog={showLog}
        setShowLog={setShowLog}

      />
      {showCreate && (
        <Create
          show={showCreate}
          onHide={setShowCreate}
          onRoles={onRoles}
          permissions={permissions}
        />
      )}


      {showRemove && (
        <Delete
          id={chooseRoleId}
          show={showRemove}
          onHide={setShowRemove}
          onRoles={onRoles}

        />
      )}


      {showEdit && (
        <Edit
          show={showEdit}
          onHide={setShowEdit}
          onRoles={onRoles}
          id={chooseRoleId}
          onRoleChoose={onRoleChoose}
          permissions={permissions}

        />
      )}
    </div>
  );
}

export default Roles;
